import { useEffect, useEffectEvent } from "react";

export const useKeyPress = (key: string, callback: () => void) => {
  const onKeyDown = useEffectEvent((e: KeyboardEvent) => {
    if (e.key === key) {
      e.preventDefault();
      e.stopPropagation();
      callback();
    }
  });
  useEffect(() => {
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, []);
};
